import { Link } from 'react-router-dom';
import { categories, getCategoryBySlug } from '@/mocks/categories';
import { getArticleBySlug } from '@/mocks/articles';

interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.label,
      item: item.to ? `https://dapiguvideo.com${item.to}` : undefined,
    })),
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <nav aria-label="面包屑导航" className="flex items-center gap-2 text-sm text-foreground-500 flex-wrap">
        {items.map((item, index) => (
          <span key={index} className="flex items-center gap-2">
            {index > 0 && (
              <i className="ri-arrow-right-s-line text-xs text-foreground-400"></i>
            )}
            {item.to ? (
              <Link
                to={item.to}
                className="hover:text-primary-600 cursor-pointer transition-colors"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-700 font-medium">{item.label}</span>
            )}
          </span>
        ))}
      </nav>
    </>
  );
}

export function buildBreadcrumbs(
  pathname: string,
  categorySlug?: string,
  articleSlug?: string,
): BreadcrumbItem[] {
  const items: BreadcrumbItem[] = [{ label: '首页', to: '/' }];

  if (categorySlug) {
    const cat = getCategoryBySlug(categorySlug);
    items.push({
      label: cat ? cat.name : '分类',
      to: `/category/${categorySlug}`,
    });
  }

  if (articleSlug) {
    const article = getArticleBySlug(articleSlug);
    items.push({
      label: article ? article.title : '文章',
    });
  } else if (pathname === '/about') {
    items.push({ label: '关于我们' });
  }

  return items;
}